import {
    // https://lucide.dev/icons/
    Bell,
    Bug,
    Cookie,
    Tag,
    Users,
    Settings,
    // Contact,
    LayoutGrid,
    SquarePen,
    Bookmark,
    Calendar,
    Image,
    Music,
    Egg,
    Mail,
    LogIn,
    File,
    ListTodo,
    FolderKanban,
    type LucideIcon,
} from "lucide-react";

type Submenu = {
    href: string;
    label: string;
    active: boolean;
};

type Menu = {
    href: string;
    label: string;
    active: boolean;
    icon: LucideIcon;
    submenus: Submenu[];
};

type Group = {
    groupLabel: string;
    menus: Menu[];
};

export function getMenuList(pathname: string): Group[] {
    return [
        {
            groupLabel: "About",
            menus: [
                {
                    href: "/about/",
                    label: "About",
                    active: pathname.includes("/about/"),
                    icon: Users,
                    submenus: [],
                },
                {
                    href: "/users/issues/",
                    label: "Issues",
                    icon: Bug,
                    active: pathname === "/users/issues/",
                    submenus: [],
                },
                {
                    href: "/members/",
                    label: "Members",
                    active: pathname.includes("/members/"),
                    icon: Users,
                    submenus: [],
                },
            ],
        },
        {
            groupLabel: "",
            menus: [
                {
                    href: "/dashboard/",
                    label: "Dashboard",
                    active: pathname.includes("/dashboard/"),
                    icon: LayoutGrid,
                    submenus: [],
                },
                {
                    href: "/mail/",
                    label: "Mail",
                    active: pathname === "/mail/",
                    icon: Mail,
                    submenus: [],
                },

                {
                    href: "/documents/",
                    label: "Documents",
                    active: pathname.includes("/documents/"),
                    icon: File,
                    submenus: [],
                },

                {
                    href: "/events/",
                    label: "Events",
                    active: pathname.includes("/events/"),
                    icon: Calendar,
                    submenus: [
                        {
                            href: "/events/new/",
                            label: "New Event",
                            active: pathname === "/events/new/",
                        },
                    ],
                },
            ],
        },
        {
            groupLabel: "Tasks",
            menus: [
                {
                    href: "/tasks/todo-list/",
                    label: "Todo List",
                    active: pathname.includes("/tasks/todo-list/"),
                    icon: ListTodo,
                    submenus: [],
                },
                {
                    href: "/tasks/projects/",
                    label: "Projects",
                    active: pathname.includes("/tasks/projects/"),
                    icon: FolderKanban,
                    submenus: [],
                },
            ],
        },
        {
            groupLabel: "Settings",
            menus: [
                {
                    href: "/settings/account/",
                    label: "Account",
                    active: pathname.includes("/account/"),
                    icon: Settings,
                    submenus: [],
                },
                {
                    href: "/settings/notifications/",
                    label: "Notifications",
                    active: pathname === "/settings/notifications/",
                    icon: Bell,
                    submenus: [],
                },
                {
                    href: "/settings/cookies/",
                    label: "Cookies",
                    active: pathname === "/settings/cookies/",
                    icon: Cookie,
                    submenus: [],
                },
            ],
        },
        {
            groupLabel: "Contents",
            menus: [
                {
                    href: "/posts/",
                    label: "Posts",
                    active: pathname.includes("/posts/"),
                    icon: SquarePen,
                    submenus: [
                        {
                            href: "/posts/",
                            label: "All Posts",
                            active: pathname === "/posts/",
                        },
                        {
                            href: "/posts/panto/",
                            label: "Panto",
                            active: pathname === "/posts/panto/",
                        },
                        {
                            href: "/posts/new/",
                            label: "New Post",
                            active: pathname === "/posts/new/",
                        },
                    ],
                },
                {
                    href: "/hens/",
                    label: "Hens",
                    active: pathname === "/hens/",
                    icon: Egg,
                    submenus: [
                        {
                            href: "/hens/cam/",
                            label: "Cam",
                            active: pathname === "/hens/cam/",
                        },
                        {
                            href: "/hens/submissions/",
                            label: "Submissions",
                            active: pathname === "/hens/submissions/",
                        },
                    ],
                },
                {
                    href: "/art/",
                    label: "Art",
                    active: pathname.includes("/art/"),
                    icon: Image,
                    submenus: [
                        {
                            href: "/studio/",
                            label: "Studio",
                            active: pathname === "/studio/",
                        },
                        {
                            href: "/art/three-d-gallery/",
                            label: "Gallery",
                            active: pathname === "/art/three-d-gallery/",
                        },
                    ],
                },
                {
                    href: "/music/",
                    label: "Music",
                    active: pathname.includes("/music/"),
                    icon: Music,
                    submenus: [
                        {
                            href: "/music/bobettes/",
                            label: "Bobettes",
                            active: pathname === "/music/bobettes/",
                        },
                        {
                            href: "/music/bobettes-2/",
                            label: "Bobettes 2",
                            active: pathname === "/music/bobettes-2/",
                        },
                        {
                            href: "/music/creepers/",
                            label: "Creepers",
                            active: pathname === "/music/creepers/",
                        },
                        {
                            href: "/music/noise/",
                            label: "Noise",
                            active: pathname === "/music/noise/",
                        },
                        {
                            href: "/music/noodleman/",
                            label: "Noodleman",
                            active: pathname === "/music/noodleman/",
                        },
                        {
                            href: "/music/ritzun/",
                            label: "Ritzun",
                            active: pathname === "/music/ritzun/",
                        },
                        {
                            href: "/music/ritzun-hard/",
                            label: "Ritzun Hard",
                            active: pathname === "/music/ritzun-hard/",
                        },
                        {
                            href: "/music/seaweed/",
                            label: "Seaweed",
                            active: pathname === "/music/seaweed/",
                        },
                    ],
                },
                {
                    href: "/posts/categories/",
                    label: "Categories",
                    active: pathname.includes("/posts/categories/"),
                    icon: Bookmark,
                    submenus: [],
                },



                {
                    href: "/posts/tags/",
                    label: "Tags",
                    active: pathname.includes("/posts/tags/"),
                    icon: Tag,
                    submenus: [],
                },
            ],
        },


    ];
}
